<template>
  <a-modal v-if="loaded"
           class="note-edit-modal"
           :visible="visible"
           width="80%"
           :closable="false"
           v-bind:class="{loaded: loaded}"
           @cancel="handleClose">
    <template slot="title">
      <div style="font-size: 15px">
        Aangemaakt onder: <a :href="parent.uri">{{ parent.description }} {{ parent.name }}</a>
      </div>
      <div style="font-size: 15px">
        Aangemaakt door: <a href="#">{{ user.fullname }}</a>
        op {{ noteDatetime }}
      </div>
    </template>
    <template>
      <a-form
          :form="form"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          @submit="handleSubmit">

        <a-form-item label="Onderwerp">
          <a-input
              placeholder="Bijvoorbeeld 'Afspraken hypotheekgesprek 29-02-2021'"
              v-model="form.title"
              name="title"
          />
        </a-form-item>

        <a-form-item label="Inhoud">
          <a-textarea
              class="a-textarea-copy"
              v-model="form.content"
              rows="5"
          />
        </a-form-item>

        <a-form-item label="Labels">
          <a-select
              mode="multiple"
              :value="selectedProductLabels"
              placeholder="Selecteer (een) label(s)"
              @change="handleSelectProductLabels"
          >
            <a-select-option v-for="label in filteredProductLabelOptions" :key="label.id" :value="label.id">
              <ShowProductLabelComponent :product-label="label"/>
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Zichtbaar voor klant">

          <a-button-group style="margin-bottom: 1.5rem">
            <a-button :type="visibleButtonType" @click="setVisible">Ja</a-button>
            <a-button :type="notVisibleButtonType" @click="setNotVisible" value="0">Nee</a-button>
          </a-button-group>
          <!--          <a-switch @change="handleChangeVisibility" :checked="Boolean(form.visible_for_customer)">-->
          <!--            <a-icon slot="checkedChildren" type="check"/>-->
          <!--            <a-icon slot="unCheckedChildren" type="close"/>-->
          <!--          </a-switch>-->
        </a-form-item>
      </a-form>
    </template>
    <template slot="footer">
      <a-button @click="handleClose">
        Annuleren
      </a-button>
      <a-button type="primary" class="save-note" @click=handleSubmit>
        Opslaan
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import NoteApi from "~/api/note";
import ShowProductLabelComponent from "~/modules/product_label/components/ShowProductLabelComponent"
import DateFormatEnum from '~/enums/DateFormatEnum';
import ProductLabelApi from "~/api/product_label"
import moment from 'moment'
import DOMPurify from "dompurify";

export default {
  name: "EditNoteModal",
  components: {ShowProductLabelComponent},
  props: {
    note: {
      type: Object,
      default: null
    },
    noteId: {
      type: [Number, String],
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      noteObject: null,
      loaded: false,
      selectedProductLabels: [],
      form: {
        id: null,
        title: null,
        content: null,
        visible_for_customer: null,
        productLabels: null,
      },
      availableProductLabels: []
    }
  },
  computed: {
    productLabels() {
      if (this.noteObject !== null && typeof this.noteObject.product_labels !== 'undefined' && this.noteObject.product_labels !== null) {
        return this.noteObject.product_labels.data;
      }
      return [];
    },
    noteDatetime() {
      if (this.noteObject !== null && this.noteObject.datetime !== null) {
        return this.noteObject.datetime ? moment(this.noteObject.datetime).format(DateFormatEnum.DATE) : ''
      }
    },
    user() {
      if (this.noteObject !== null && typeof this.noteObject.user !== 'undefined' && this.noteObject.user !== null) {
        return this.noteObject ? this.noteObject.user.data : {}
      }
      return {};
    },
    parent() {
      if (this.noteObject !== null && typeof this.noteObject.attachable !== 'undefined' && this.noteObject.attachable !== null
          && typeof this.noteObject.attachable.data.parent_instance !== 'undefined' && this.noteObject.attachable.data.parent_instance !== null) {
        return this.noteObject ? this.noteObject.attachable.data.parent_instance.data : {}
      }
      return {};
    },
    filteredProductLabelOptions() {
      return this.availableProductLabels.filter(o => !this.selectedProductLabels.includes(o));
    },
    visibleButtonType() {
      return this.form.visible_for_customer ? 'primary' : 'default';
    },
    notVisibleButtonType() {
      return this.form.visible_for_customer ? 'default' : 'primary';
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleSubmit() {
      this.form = {
        ...this.form,
        title: DOMPurify.sanitize(this.form.title),
        content: DOMPurify.sanitize(this.form.content)
      };

      NoteApi.update(this.form).then((response) => {
        this.$notification['success']({
          message: 'Success',
          description: 'De notitie is aangepast',
        });
        this.$emit('note-updated')
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt de notitie aan te passen',
        });
      });
    },
    setVisible() {
      this.form.visible_for_customer = true;
    },
    setNotVisible() {
      this.form.visible_for_customer = false;
    },
    handleSelectProductLabels(value) {
      this.selectedProductLabels = value;
      this.form.product_labels = value;
    },
    initNote() {
      if (this.note !== null) {
        this.noteObject = this.note
        this.loadForm()
        this.selectedProductLabels = this.getProductLabelIds()
        this.loaded = true;
      } else if (this.noteId !== null) {
        NoteApi.find(this.noteId, ['product_labels', 'user', 'attachable.parent_instance']).then((response) => {
          this.noteObject = response.data
          this.loadForm()
          this.selectedProductLabels = this.getProductLabelIds()
          this.loaded = true;
        })
      } else {
        throw new Error('Either the note object or note id is required.');
      }
    },
    loadForm() {
      this.form.id = this.noteObject.id;
      this.form.title = this.noteObject.title;
      this.form.content = this.noteObject.content;
      this.form.visible_for_customer = this.noteObject.visible_for_customer
      this.form.product_labels = this.getProductLabelIds()
    },
    getProductLabelIds() {
      let ids = []
      this.productLabels.forEach(function (label) {
        ids.push(label.id);
      })
      return ids
    },
  },
  mounted() {
    ProductLabelApi.getByProductCategory('note').then((response) => {
      this.availableProductLabels = response.data;
    })
    this.initNote();
  }
}
</script>

<style scoped>
.a-textarea-copy {
  white-space: pre-wrap !important;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  max-width: 100%;
  min-height: 64px;
  max-height: 600px;
  line-height: 1.5;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
  overflow: auto;
  resize: vertical;
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
</style>